var exports = {
  "kL": "xf61da738--363443--container",
  "jq": "xf61da738--363443--contact",
  "Fu": "xf61da738--363443--contact-logo",
  "bm": "xf61da738--363443--contact-content",
  "ao": "xf61da738--363443--contact-description",
};

module.exports = exports;
